<template>
  <v-card width="800" elevation="0">
    <v-container>
      <v-row justify="center" mb-4>
        <v-col cols="5" align-self="center">
          <!-- The v-select was loading only 20 items. :menu-props="'auto'" is a workaround found here: https://github.com/vuetifyjs/vuetify/issues/2660 -->
          <v-select
            v-model="fromUnit"
            :dense="true"
            :label="'from'"
            :items="fromUnitItems"
            :menu-props="'auto'"
          >
          </v-select>
        </v-col>
        <v-col cols="1">
          <v-spacer></v-spacer>
        </v-col>
        <v-col cols="5" align-self="center">
          <v-select
            v-model="toUnit"
            :dense="true"
            :label="'to'"
            :items="toUnits[fromUnit]"
            :menu-props="'auto'"
          >
          </v-select>
        </v-col>
      </v-row>
      <v-divider></v-divider>
      <v-row justify="center" mt-4>
        <v-col cols="5" align-self="center">
          <v-text-field v-model="inputModel" placeholder="input">
          </v-text-field>
        </v-col>
        <v-col cols="1" align-self="center">
          <icon name="arrow-right" class="ml-4"></icon>
        </v-col>
        <v-col cols="5" align-self="center">
          <v-text-field
            readonly
            outlined
            placeholder="result"
            :value="result"
            :label="toUnit"
          >
          </v-text-field>
        </v-col>
      </v-row>
    </v-container>
  </v-card>
</template>

<script>
import dataDescription from '../../tools/dataDescription.json'
import dataTools from '../../tools/data.js'

export default {
  name: 'UnitsConverter',

  data() {
    return {
      allUnits: [],
      toUnits: {},
      fromUnit: undefined,
      toUnit: undefined,
      inputModel: '',
      result: ''
    }
  },

  mounted() {
    this.initConversions()
    this.setInitialFromUnit()
  },

  watch: {
    fromUnit(newValue) {
      localStorage.setItem('unitsConverterFrom', JSON.stringify(newValue))
      this.inputModel = ''
      this.result = ''
      this.toUnit = this.toUnits[newValue][0]
    },
    toUnit(newValue) {
      this.conversion()
    },
    inputModel() {
      this.conversion()
    }
  },

  computed: {
    fromUnitItems: function () {
      let fromItems = []
      this.allUnits.forEach((unit) => {
        if (this.toUnits[unit] && this.toUnits[unit].length > 0) {
          fromItems.push(unit)
        }
      })
      return fromItems
    }
  },

  methods: {
    initConversions() {
      this.toUnits = {}
      this.allUnits = []
      Object.keys(dataDescription).forEach((fieldName) => {
        if (fieldName !== 'percentage') {
          let field = dataDescription[fieldName]

          if (field.siUnit && !this.allUnits.includes(field.siUnit)) {
            this.toUnits[field.siUnit] = []
            let conversionUnits = dataTools.getConversionUnits(field.siUnit)
            conversionUnits.forEach((unit) => {
              if (unit !== field.siUnit) {
                this.toUnits[field.siUnit].push(unit)
              }
            })
            this.allUnits.push(field.siUnit)
          }

          if (field.guiUnit && !this.allUnits.includes(field.guiUnit)) {
            this.toUnits[field.guiUnit] = []
            let conversionUnits = dataTools.getConversionUnits(field.guiUnit)
            conversionUnits.forEach((unit) => {
              if (unit !== field.guiUnit) {
                this.toUnits[field.guiUnit].push(unit)
              }
            })
            this.allUnits.push(field.guiUnit)
          }
        }
      })
    },
    setInitialFromUnit() {
      if (this.allUnits.length > 1) {
        let localfromUnit = JSON.parse(
          localStorage.getItem('unitsConverterFrom')
        )
        if (!localfromUnit) {
          localStorage.setItem('unitsConverterFrom', this.allUnits[0])
          localfromUnit = this.allUnits[0]
        }
        this.fromUnit = localfromUnit
      }
    },
    conversion() {
      this.result = ''
      let input = this.inputModel.replace(' ', '').replace(',', '.')
      this.result = dataTools.convertUnits(input, this.fromUnit, this.toUnit)
    }
  }
}
</script>
